import { Component, Input, OnInit } from '@angular/core';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { Step } from './step';
import { Steps } from './steps';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    selector: 'app-stepper-component',
    templateUrl: './stepper.component.html',
    styleUrls: [],
})
export class StepperComponent implements OnInit {
    @Input() currentStepId: string;
    currentStep: Step;
    steps: Step[];

    constructor(
        private i18nPipe: I18nPipe,
        private routerHelperService: RouterHelperService
    ) {}

    ngOnInit() {
        const showSignturePropoStep =
            this.routerHelperService.isStatutSignaturePropo() ||
            this.routerHelperService.isStatutFinalisationAfterPropoSignature();

        this.steps = Steps.getInitalSteps(
            this.i18nPipe,
            showSignturePropoStep,
            this.routerHelperService.getTopSansSelectionMedicale()
        );
        if (this.currentStepId) {
            const currentStepIndex = this.steps.findIndex(
                (step) => step.id === this.currentStepId
            );
            if (currentStepIndex > -1) {
                this.steps[currentStepIndex].isCurrent = true;
            }
        }
    }
}
